import React from "react";

import Button from "../../atoms/Button";

const AboutUsBody = () => {
  const backgroundImage = "url('/images/offsetaboutus-background.svg')";
  return (
    <div>
      <div className="flex flex-col items-center text-center  bg-white ">
        <div className="text-[55px] font-bold">
          Welcome to the{" "}
          <span className="text-blue-800">Offsetgo Marketplace</span>
        </div>
        <div className="text-[30px] font-medium pt-4">
          Get set go with Offset Go
        </div>
        <div  className="mt-[-7rem] relative w-full h-full">
          <img src="images/about-us-header.svg" alt="about-us" loading="lazy" />
        </div>
      </div>

      <div className="flex font-sans pb-16 flex-col items-center text-center px-32 pt-8 bg-grey-40">
        <div>
          {" "}
          <div className="text-[28px] font-bold ">
            About <span className="text-blue-800">Offsetgo</span>
          </div>
          <p className="text-[16px] font-medium">
            OffsetGo is an innovative consultancy committed to addressing the
            urgent challenges of climate change and sustainable development,
            specializing in environmental services with offering a wide range of
            solutions tailored to meet the needs of businesses, organizations,
            and governments. Through its innovative carbon credit marketplace,
            comprehensive ESG reporting, SDG scoring, and educational
            initiatives, OffsetGo is making significant strides in the fight
            against climate change and promoting sustainable development.
          </p>
        </div>
      </div>
      <div className="flex font-sans items-end text-end px-16 pb-20 pt-8 bg-white">
        <div className="w-1/3">
          <img
            src="images/carbon-revoluzion.svg"
            alt="about-us"
            // style={{ width: "55px", height: "55px" }}
          />
        </div>
        <div className="w-2/3 text-[28px] font-bold  flex flex-col ">
          <h1>
            Revolutionizing the Carbon Credit Market with{" "}
            <span className="text-blue-800">OffsetGo Marketplace</span>
          </h1>

          <p className="text-[16px] font-normal">
            OffsetGo marketplace is a blockchain-enabled platform that
            facilitates the buying and selling of carbon credits or offsets.
            These credits represent a reduction or removal of greenhouse gas
            emissions from the atmosphere. Companies or individuals looking to
            compensate for their carbon emissions can purchase these credits to
            support projects that contribute to environmental sustainability.
            Conversely, organizations that implement projects leading to
            emission reductions or removals can sell their generated carbon
            credits on the platform.
          </p>
        </div>
      </div>
      <div className="flex font-sans pb-16 gap-x-10 items-left text-left px-16 pt-20 bg-grey-40">
        <div className="flex flex-col w-1/3">
          {" "}
          <div className="text-[28px] font-bold ">
            Benifits of{" "}
            <span className="text-blue-800">OffsetGo's Marketplace</span>
          </div>
          <p className="text-[16px] font-medium">
            OffsetGo's marketplace stands out by offering a comprehensive and
            transparent platform  that brings together buyers, sellers, and
            traders in a seamless trading environment. The integration of
            blockchain technology ensures that every transaction is secure and
            transparent, fostering trust among participants.
          </p>
        </div>
        <div className="flex flex-col w-1/3 h-fit py-6 px-7 bg-white rounded-xl">
          {" "}
          <div className="text-[25px] font-bold ">For</div>
          <span className="text-blue-800 text-[25px] font-bold ">Buyer</span>
          <p className="text-[15px] font-medium">
            the platform offers a broad selection of carbon credits, detailed
            information on each credit's journey and impact, and tools to
            compare prices and negotiate deals. The OG score further aids in
            making environmentally conscious decisions, while flexible credit
            management options enhance convenience.
          </p>
        </div>
        <div className="flex flex-col w-1/3 h-fit py-6 px-7 bg-white rounded-xl">
          {" "}
          <div className="text-[25px] font-bold ">For</div>
          <span className="text-blue-800 text-[25px] font-bold ">Seller</span>
          <p className="text-[15px] font-medium">
            the marketplace provides the opportunity to reach a diverse and
            extensive client base, set competitive prices, and make informed
            decisions based on buyer ratings. The platform also supports
            continuous improvement by allowing sellers to track their ratings
            and enhance the impact of their projects.
          </p>
        </div>
      </div>
      <div
        className="relative bg-cover bg-center pb-20 bg-no-repeat"
        style={{ backgroundImage }}
      >
        <div className="p-8 flex flex-col items-center justify-center rounded-lg  px-20 mb-16">
          <h1 className="text-[40px] font-bold text-white mb-4">
            Introducing OG Score
          </h1>
          <p className="text-[15px] text-white ">
            To address the need for a reliable evaluation method, OffsetGo has
            developed a customized algorithm that involves numerous key
            parameters and rigorous assessment criteria. This unique scoring
            system is named OG scoring. The OG score derived from the OG scoring
            assesses carbon credits based on three key factors: the quality of
            the project, their impact on the Sustainable Development Goals
            (SDGs), and the Life Cycle Assessment (LCA) of the entire project.
          </p>
        </div>
        <div className="flex flex-col gap-y-6">
          <div className="flex border bg-white mx-40 rounded-lg">
            <div className="pl-6 w-1/3">
              <img src="images/environment.svg" alt="about-us" />
            </div>
            <div className="flex w-2/3 flex-col pt-6">
              <div>
                {" "}
                <img src="images/audit.svg" alt="about-us" />
              </div>
              <h1 className="font-bold">Quality of the Project</h1>
              <p className="text-[16px] pr-6">
                This factor evaluates the intrinsic attributes of the project
                generating the carbon credits. It includes external impacts like
                additionality, permanence, transparency, etc, and internal
                assessments of project design, implementation, monitoring, and
                verification processes. Projects that demonstrate high levels of
                transparency, reliability, and effectiveness in reducing or
                removing greenhouse gases score higher in this category.
              </p>
            </div>
          </div>
          <div className="flex border bg-white mx-40 py-6 rounded-lg">
            <div className="pl-6 w-1/3">
              <img src="images/charts.svg" alt="about-us" />
            </div>
            <div className="flex w-2/3 flex-col">
              <div>
                {" "}
                <img src="images/businessaudit.svg" alt="about-us" />
              </div>
              <h1 className="font-bold">SDG Impact</h1>
              <p className="text-[16px] pr-6">
                Carbon offset projects often have broader social, economic, and
                environmental impacts beyond just reducing CO2 emissions. This
                factor examines how well a project contributes to the United
                Nations' Sustainable Development Goals. Projects that provide
                significant co-benefits, such as improving local livelihoods,
                enhancing biodiversity, and fostering sustainable economic
                development, are rated more favorably.
              </p>
            </div>
          </div>
          <div className="flex border bg-white py-6 mx-40 rounded-lg">
            <div className="pl-6 w-1/3">
              <img src="images/scrum.svg" alt="about-us" />
            </div>
            <div className="flex w-2/3 flex-col ">
              <div>
                {" "}
                <img src="images/lifecycleassesment.svg" alt="about-us" />
              </div>
              <h1 className="font-bold">Life Cycle Assessment (LCA)</h1>
              <p className="text-[16px] pr-6">
                LCA is a comprehensive method used to evaluate the environmental
                impacts associated with all stages of a project’s life, from raw
                material extraction to disposal or recycling. This factor
                assesses the overall environmental footprint of the project,
                considering not only the greenhouse gas reductions but also
                other potential environmental effects. Projects with a lower
                overall environmental impact score higher in this category.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="">
        <div className="p-8 flex flex-col items-center justify-center rounded-lg  px-20 mb-16">
          <h1 className="text-[28px] font-bold mb-4">
            The OG Scoring System and tokenization
          </h1>
          <p className="text-[16px] font-medium ">
            Based on the described key factors, OffsetGo’s algorithm generates
            an OG score for each carbon credit providing a clear and concise
            metric for evaluation. After evaluating carbon credits with the OG
            scoring system, each credit is tokenized, with one token
            representing one carbon credit. This means each token signifies one
            tonne of carbon saved, ensuring a clear and transparent link between
            the credit's environmental impact and its representation on the
            platform. To simplify the trading process and make it more
            accessible, OffsetGo classifies the tokens into three categories
            based on their OG scores: Gold, Silver, and Bronze.
          </p>
        </div>
        <div className="flex">
          <div className="relative flex items-center justify-center pb-8">
            <div className="relative  bg-center  bg-no-repeat">
              <img src="images/aboutus-silver.svg" alt="about-us" />

              <div className="absolute inset-0 p-8 flex flex-col items-center justify-center rounded-lg px-20 mt-64 bg-opacity-75 z-10">
                <h1 className="text-[28px] font-bold pb-4">
                  Silver <span className="text-blue-800">Token</span>
                </h1>
                <p className="text-[16px] font-normal">
                  Silver tokens are assigned to projects that perform well
                  across the three key factors but may not achieve the highest
                  scores in all categories. They offer substantial environmental
                  and economic benefits and are a reliable choice for buyers
                  looking for a balanced investment.
                </p>
              </div>
            </div>
            <div className="relative  bg-center  bg-no-repeat">
              <img src="images/aboutus-gold.svg" alt="about-us" />

              <div className="absolute inset-0 p-8 flex flex-col items-center justify-center rounded-lg px-20 mt-64 bg-opacity-75 z-10">
                <h1 className="text-[28px] font-bold pb-4">
                  Gold <span className="text-blue-800">Token</span>
                </h1>
                <p className="text-[16px] font-normal">
                  These are the highest-rated tokens, assigned to representing
                  projects with exceptional internal quality, significant SDG
                  impacts, and minimal overall environmental footprints. Gold
                  tokens are highly sought after for their superior benefits and
                  contributions to sustainability.
                </p>
              </div>
            </div>
            <div className="relative  bg-center  bg-no-repeat">
              <img src="images/aboutus-bronze.svg" alt="about-us" />

              <div className="absolute inset-0 p-8 flex flex-col items-center justify-center rounded-lg px-20 mt-80 bg-opacity-75 z-10">
                <h1 className="text-[28px] font-bold pb-4">
                  Bronze <span className="text-blue-800">Token</span>
                </h1>
                <p className="text-[16px] font-normal">
                  Bronze tokens are assigned to projects that meet the essential
                  criteria for carbon offsetting but may have lower scores in
                  one or more of the key factors. While still contributing
                  positively to climate goals, these credits are more suitable
                  for buyers with specific budget constraints or those looking
                  to support emerging or smaller-scale projects.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="py-8 px-20  bg-white">
        <h1 className="text-[16px] font-bold pb-4">
          Note: One token represents one tonne of emission saved.
        </h1>
        <p className="text-[16px] font-normal">
          All credits on the OffsetGo marketplace are issued with one of these
          three tokens, providing a straightforward and transparent way for
          buyers to understand the value and impact of their purchases. This
          rating system not only facilitates informed decision-making but also
          promotes higher standards and greater accountability in the carbon
          offset market, driving the global effort towards sustainability and
          climate resilience.
        </p>
      </div>
      <div>
        <div className="py-8  mb-16 bg-white">
          <h1 className="flex justify-center items-center text-[60px] font-bold mb-4  bg-grey-40 ">
            <span className="text-blue-800">Blockchain</span> Technology
          </h1>
        </div>
        <div className="flex">
          <div className=" w-3/5 py-8 text-[28px] px-20 mb-16 ">
            <h1 className=" font-bold mb-4   ">
              Why is{" "}
              <span className="text-blue-800"> Blockchain Technology</span>{" "}
              important?
            </h1>
            <p className="text-[16px] font-medium">
              The key advantages of blockchain technology include its
              transparency, security, and immutability. Transparency is achieved
              through the decentralized nature of the ledger, where all
              participants have access to the same data, fostering trust.
              Security is ensured by cryptographic methods that protect data
              integrity, while immutability guarantees that once data is added
              to the blockchain, it cannot be changed, thus preventing fraud and
              tampering.
            </p>
          </div>
          <div className="w-2/5 px-8">
            {" "}
            <img src="images/blockchain.svg" alt="about-us" />
          </div>
        </div>
      </div>
      <div className="flex bg-white pb-24">
        <div className="w-2/5 px-8">
          <img src="images/blockchain-role.svg" alt="about-us" />
        </div>
        <div className="w-3/5 py-8 text-[28px] px-20 mb-16 mt-16 flex flex-col items-end">
          <h1 className="font-bold mb-4 text-right">
            Blockchain's Role in the{" "}
            <span className="text-blue-800">Carbon Market</span>
          </h1>
          <p className="text-[16px] font-medium text-right">
            In the carbon market, transparency and traceability are crucial for
            ensuring the credibility and effectiveness of carbon credits.
            Blockchain technology addresses these needs by providing a
            tamper-proof record of each carbon credit’s lifecycle, from issuance
            to retirement. This allows buyers to trace the entire journey of
            their credits, verifying their authenticity and impact.
            Additionally, blockchain facilitates efficient trading by enabling
            secure and transparent transactions, reducing the risk of fraud, and
            ensuring compliance with market standards.
          </p>
        </div>
      </div>
      <div className="py-8 text-[28px] px-20 mb-16 mt-16 flex flex-col items-center">
        <h1 className="font-bold mb-4  text-right">
          OffsetGo’s Exceptional Integration of {""}
          <span className="text-blue-800">Blockchain Technology</span>
        </h1>
        <p className="text-[16px] font-medium text-center">
          OffsetGo has leveraged blockchain technology to enhance the
          functionality and credibility of its carbon credit marketplace. Here’s
          how OffsetGo stands out with its integration of blockchain:
        </p>
        <div className="px-8 pt-12 pb-10">
          <img src="images/blockintegration.svg" alt="about-us" />
        </div>
      </div>
      <div>
        <div className="py-8   bg-white">
          <h1 className="flex justify-center  items-center text-[60px] font-bold bg-blue-100 ">
            <span className="text-blue-800">Stakeholders</span>
          </h1>
        </div>
        <div className="text-[28px] px-20  flex items-center bg-white">
          <div className="flex w-4/5 flex-col">
            <h1 className="mb-4  text-left">
              <span className="text-blue-800 font-bold">BUYER</span>
            </h1>
            <p className="text-[16px] font-medium text-left">
              OffsetGo Marketplace provides a comprehensive suite of services
              catering to informed and thoughtful buyers as well as new entrants
              to the market seeking to actively engage in emissions management
              and sustainability initiatives. It transcends the conventional
              marketplace model by presenting a holistic suite of services
              encompassing various emission mitigation strategies.
            </p>
          </div>
          <div className="px-8  pb-10">
            <img src="images/aboutus-buyer.svg" alt="about-us" />
          </div>
        </div>
        <div className="px-20 bg-white pb-16">
          <h1 className="mb-4  text-left">
            <span className="text-blue-800 text-[25px] font-bold">
              Facilities for Buyers:
            </span>
          </h1>
          <p className="text-[16px] font-medium text-left">
            OffsetGo's marketplace offers an unparalleled experience for buyers
            of carbon credits.
          </p>
        </div>
        <div className="flex  px-20">
          <div className="flex  w-1/2 gap-x-24">
            <div className="pt-6">
              <img src="images/block1.svg" alt="about-us" />
            </div>
            <div className="w-4/5 flex flex-col pt-5 pb-10 ">
              {" "}
              <h1 className="mb-4 ">
                <span className="text-blue-800 text-[25px] font-bold">
                  Blockchain Transparency
                </span>
              </h1>
              <p className="text-[12px] font-medium ">
                By integrating blockchain technology, the platform ensures that
                buyers can trace the entire journey of the credits they are
                interested in, from inception onto the platform to the present
                day. This transparency builds trust and confidence, allowing
                buyers to make informed decisions.
              </p>
            </div>
          </div>
          <div className="flex  w-1/2 gap-x-24 ">
            <div className="pt-6">
              <img src="images/block2.svg" alt="about-us" />
            </div>
            <div className="w-4/5 flex flex-col pt-5 pb-10 ">
              {" "}
              <h1 className="mb-4 ">
                <span className="text-blue-800 text-[25px] font-bold">
                  Diverse Project Selection
                </span>
              </h1>
              <p className="text-[12px] font-medium ">
                The platform aggregates national and international projects,
                providing a vast array of credits to choose from, based on
                various criteria such as vintage, type, technology, and
                environmental impact.
              </p>
            </div>
          </div>
        </div>
        <div className="flex  px-20 bg-white">
          <div className="flex  w-1/2 gap-x-24">
            <div className="pt-6">
              <img src="images/block3.svg" alt="about-us" />
            </div>
            <div className="w-4/5 flex flex-col pt-5 pb-10 ">
              {" "}
              <h1 className="mb-4 ">
                <span className="text-blue-800 text-[25px] font-bold">
                  OG Score for Environmental Impact
                </span>
              </h1>
              <p className="text-[12px] font-medium ">
                To assist buyers in evaluating the environmental benefits of the
                credits, OffsetGo introduces the OG score. This unique scoring
                system assesses the impact of each credit, with higher scores
                indicating greater environmental benefits. This feature empowers
                buyers to prioritize credits that have a more substantial
                positive impact on the environment.
              </p>
            </div>
          </div>
          <div className="flex  w-1/2 gap-x-24 ">
            <div className="pt-6">
              <img src="images/block4.svg" alt="about-us" />
            </div>
            <div className="w-4/5 flex flex-col pt-5 pb-10 ">
              {" "}
              <h1 className="mb-4 ">
                <span className="text-blue-800 text-[25px] font-bold">
                  Price Comparison and Negotiation
                </span>
              </h1>
              <p className="text-[12px] font-medium ">
                OffsetGo facilitates price comparisons by providing the market
                price for different credits, enabling buyers to negotiate and
                counter the prices set by sellers.
              </p>
            </div>
          </div>
        </div>
        <div className="flex  px-20">
          <div className="flex  w-1/2 gap-x-24">
            <div className="pt-6">
              <img src="images/block5.svg" alt="about-us" />
            </div>
            <div className="w-4/5 flex flex-col pt-5 pb-10 ">
              {" "}
              <h1 className="mb-4 ">
                <span className="text-blue-800 text-[25px] font-bold">
                  Flexible Credit Management
                </span>
              </h1>
              <p className="text-[12px] font-medium ">
                The platform also offers flexibility in terms of credit
                management. Buyers can purchase credits and store them in their
                digital wallets, deciding when to retire them based on their
                needs. For added convenience, OffsetGo provides a one-click
                retirement option, allowing buyers to retire credits instantly
                through the platform.
              </p>
            </div>
          </div>
          <div className="flex  w-1/2 gap-x-24 ">
            <div className="pt-6">
              <img src="images/block6.svg" alt="about-us" />
            </div>
            <div className="w-4/5 flex flex-col pt-5 pb-10 ">
              {" "}
              <h1 className="mb-4 ">
                <span className="text-blue-800 text-[25px] font-bold">
                  Tailored Service Options
                </span>
              </h1>
              <p className="text-[12px] font-medium ">
                It also offers buyers the flexibility to choose from an array of
                services tailored to their specific needs like carbon footprint
                accounting, organic decarbonisation strategy, net zero business,
                net zero products etc.
              </p>
            </div>
          </div>
        </div>
        <div className="text-[28px] px-20  flex items-center bg-white">
          <div className="flex w-4/5 flex-col">
            <h1 className="mb-4  text-left">
              <span className="text-blue-800 font-bold">Sellers</span>
            </h1>
            <p className="text-[16px] font-medium text-left">
              The OffsetGo marketplace features a diverse range of sellers from
              around the world, offering carbon credits from various types of
              environmental projects. Each seller is vetted to ensure the
              quality and integrity of the credits they provide, ensuring
              reliable and impactful carbon offsetting options.
            </p>
          </div>
          <div className="px-8  pb-10">
            <img src="images/aboutus-seller.svg" alt="about-us" />
          </div>
        </div>
        <div className="px-20 bg-white pb-16">
          <h1 className="mb-4  text-left">
            <span className="text-blue-800 text-[25px] font-bold">
              Facilities for Sellers:
            </span>
          </h1>
          <p className="text-[16px] font-medium text-left">
            OffsetGo offers several benefits for sellers of carbon credits,
            enhancing their ability to reach a wider audience and maximize their
            returns.
          </p>
        </div>
        <div className="flex  px-20">
          <div className="flex  w-1/2 gap-x-24">
            <div className="pt-6">
              <img src="images/block7.svg" alt="about-us" />
            </div>
            <div className="w-4/5 flex flex-col pt-5 pb-10 ">
              {" "}
              <h1 className="mb-4 ">
                <span className="text-blue-800 text-[25px] font-bold">
                  Freedom to Set Prices
                </span>
              </h1>
              <p className="text-[12px] font-medium ">
                Sellers have the freedom to set their own prices, reflecting the
                value they assign to their credits.
              </p>
            </div>
          </div>
          <div className="flex  w-1/2 gap-x-24 ">
            <div className="pt-6">
              <img src="images/block8.svg" alt="about-us" />
            </div>
            <div className="w-4/5 flex flex-col pt-5 pb-10 ">
              {" "}
              <h1 className="mb-4 ">
                <span className="text-blue-800 text-[25px] font-bold">
                  Access to a Global Market
                </span>
              </h1>
              <p className="text-[12px] font-medium ">
                The platform also provides access to a global market, connecting
                sellers with both national and international clients.
              </p>
            </div>
          </div>
        </div>
        <div className="flex  px-20 bg-white">
          <div className="flex  w-1/2 gap-x-24">
            <div className="pt-6">
              <img src="images/block9.svg" alt="about-us" />
            </div>
            <div className="w-4/5 flex flex-col pt-5 pb-10 ">
              {" "}
              <h1 className="mb-4 ">
                <span className="text-blue-800 text-[25px] font-bold">
                  Buyer Profile Visibility
                </span>
              </h1>
              <p className="text-[12px] font-medium ">
                One of the standout features for sellers is the ability to view
                buyer profiles, complete with ratings based on past
                transactions. This rating system helps sellers evaluate
                potential buyers, fostering a trustworthy and reliable trading
                environment.
              </p>
            </div>
          </div>
          <div className="flex  w-1/2 gap-x-24 ">
            <div className="pt-6">
              <img src="images/block10.svg" alt="about-us" />
            </div>
            <div className="w-4/5 flex flex-col pt-5 pb-10 ">
              {" "}
              <h1 className="mb-4 ">
                <span className="text-blue-800 text-[25px] font-bold">
                  Seller Ratings and Benchmarking
                </span>
              </h1>
              <p className="text-[12px] font-medium ">
                Additionally, sellers receive their own ratings, which reflect
                the impact of their projects and can serve as a benchmark for
                improvement.
              </p>
            </div>
          </div>
        </div>
        <div className="text-[28px] px-20 pb-6 flex items-center bg-white">
          <div className="flex w-4/5 flex-col">
            <h1 className="mb-4  text-left">
              <span className="text-blue-800 font-bold">TRADER</span>
            </h1>
            <p className="text-[16px] font-medium text-left">
              OffsetGo’s marketplace is a dynamic hub for traders who play a
              pivotal role in the carbon credit ecosystem. These traders,
              equipped with extensive market knowledge and expertise, facilitate
              the buying and selling of carbon credits, ensuring liquidity and
              market efficiency. They act as intermediaries, connecting buyers
              seeking to offset their carbon footprints with sellers offering
              high-quality credits from diverse environmental projects. Traders
              on OffsetGo leverage the platform's transparency and advanced
              features to track the journey and authenticity of carbon credits,
              ensuring secure, verifiable transactions in compliance with global
              standards.
            </p>
          </div>
          <div className="px-8  pb-10">
            <img src="images/aboutus-trader.svg" alt="about-us" />
          </div>
        </div>
        <div className="px-20 bg-white pb-16">
          <h1 className="mb-4  text-left">
            <span className="text-blue-800 text-[25px] font-bold">
              Facilities for Trader:
            </span>
          </h1>
        </div>
        <div className="flex  px-20">
          <div className="flex  w-1/2 gap-x-24">
            <div className="pt-6">
              <img src="images/block1.svg" alt="about-us" />
            </div>
            <div className="w-4/5 flex flex-col pt-5 pb-10 ">
              {" "}
              <h1 className="mb-4 ">
                <span className="text-blue-800 text-[25px] font-bold">
                  Advanced Tracking and Transparency
                </span>
              </h1>
              <p className="text-[12px] font-medium ">
                Traders are Utilizing blockchain technology to ensure the
                traceability and authenticity of carbon credits.
              </p>
            </div>
          </div>
          <div className="flex  w-1/2 gap-x-24 ">
            <div className="pt-6">
              <img src="images/block11.svg" alt="about-us" />
            </div>
            <div className="w-4/5 flex flex-col pt-5 pb-10 ">
              {" "}
              <h1 className="mb-4 ">
                <span className="text-blue-800 text-[25px] font-bold">
                  Market Insights and Analytics
                </span>
              </h1>
              <p className="text-[12px] font-medium ">
                Access valuable market data and pricing information to make
                informed trading decisions.
              </p>
            </div>
          </div>
        </div>
        <div className="flex  px-20 bg-white">
          <div className="flex  w-1/2 gap-x-24">
            <div className="pt-6">
              <img src="images/block12.svg" alt="about-us" />
            </div>
            <div className="w-4/5 flex flex-col pt-5 pb-10 ">
              {" "}
              <h1 className="mb-4 ">
                <span className="text-blue-800 text-[25px] font-bold">
                  Secure Transactions
                </span>
              </h1>
              <p className="text-[12px] font-medium ">
                Benefit from secure, verifiable transactions that adhere to
                global compliance standards.
              </p>
            </div>
          </div>
          <div className="flex  w-1/2 gap-x-24 ">
            <div className="pt-6">
              <img src="images/block2.svg" alt="about-us" />
            </div>
            <div className="w-4/5 flex flex-col pt-5 pb-10 ">
              {" "}
              <h1 className="mb-4 ">
                <span className="text-blue-800 text-[25px] font-bold">
                  Diverse Credit Options
                </span>
              </h1>
              <p className="text-[12px] font-medium ">
                Trade in a wide range of high-quality carbon credits from
                various environmental projects worldwide.
              </p>
            </div>
          </div>
        </div>
        <div className="flex  px-20">
          <div className="flex  w-1/2 gap-x-24">
            <div className="pt-6">
              <img src="images/block14.svg" alt="about-us" />
            </div>
            <div className="w-4/5 flex flex-col pt-5 pb-10 ">
              {" "}
              <h1 className="mb-4 ">
                <span className="text-blue-800 text-[25px] font-bold">
                  Tailored Service Options
                </span>
              </h1>
              <p className="text-[12px] font-medium ">
                It also offers buyers the flexibility to choose from an array of
                services tailored to their specific needs like carbon footprint
                accounting, organic decarbonisation strategy, net zero business,
                net zero products etc.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div>
          {" "}
          <h1 className="text-[60px] text-center pt-8 font-bold bg-white">
            Our Other <span className="text-blue-800 ">Offerings</span>
          </h1>
        </div>
        <div className="flex px-12 gap-x-5 bg-white">
          <div className="flex flex-col w-1/4 rounded-md shadow-lg  bg-white h-[400px]">
            <div className="pt-6 flex justify-center items-center pb-4">
              <img src="images/offering1.svg" alt="about-us" />
            </div>
            <h1 className="mb-4 text-[16px] text-center font-bold bg-white">
              Corporate Carbon Footprint
            </h1>
            <p className="text-[15px] font-medium text-center px-8">
              Don’t be the eco-villain! Track your carbon footprint and keep
              your impact on the down-low. Let’s make sure your environmental
              game is as cool as your style!
            </p>
          </div>
          <div className="flex flex-col w-1/4 mb-5 rounded-md shadow-lg  bg-white h-[400px]">
            <div className="pt-6 flex justify-center items-center pb-4">
              <img src="images/offering2.svg" alt="about-us" />
            </div>
            <a
              href="https://www.offsetgo.earth/carbon-mitigation-reduction-service"
              className="block mb-4 text-[16px] text-center font-bold bg-white"
              target="_blank"
              rel="noopener noreferrer"
            >
              Mitigation & Reduction
            </a>
            <p className="text-[15px] font-medium text-center px-8">
              Cut the carbon fat! Trim those emissions down like it’s an
              eco-friendly fitness boot camp. Less is more when it comes to
              saving the Earth.
            </p>
          </div>{" "}
          <div className="flex flex-col w-1/4 rounded-md shadow-lg  bg-white h-[400px]">
            <div className="pt-6 flex justify-center items-center pb-4">
              <img src="images/offering3.svg" alt="about-us" />
            </div>
            <a
              href="https://www.offsetgo.earth/life-cycle-assessment-service"
              className="block mb-4 text-[16px] text-center font-bold bg-white"
              target="_blank"
              rel="noopener noreferrer"
            >
              Life Cycle Assesment
            </a>
            <p className="text-[15px] font-medium text-center px-8">
              Don’t be the eco-villain! Track your carbon footprint and keep
              your impact on the down-low. Let’s make sure your environmental
              game is as cool as your style!
            </p>
          </div>{" "}
          <div className="flex flex-col w-1/4 rounded-md shadow-lg  bg-white h-[400px]">
            <div className="pt-6 flex justify-center items-center pb-4">
              <img src="images/offering4.svg" alt="about-us" />
            </div>
            <a
              href="https://www.offsetgo.earth/esg-reporting-service"
              className="block mb-4 text-[16px] text-center font-bold bg-white"
              target="_blank"
              rel="noopener noreferrer"
            >
              ESG Reporting
            </a>
            <p className="text-[15px] font-medium text-center px-8">
              Don’t be the eco-villain! Track your carbon footprint and keep
              your impact on the down-low. Let’s make sure your environmental
              game is as cool as your style!
            </p>
          </div>
        </div>
        <div className="flex px-12 gap-x-5 bg-white pb-20">
          <div className="flex flex-col w-1/4 rounded-md shadow-lg  bg-white h-[400px]">
            <div className="pt-6 flex justify-center items-center pb-4">
              <img src="images/offering5.svg" alt="about-us" />
            </div>

            <a
              href="https://www.offsetgo.earth/carbon-credit-project-development"
              className="block mb-4 text-[16px] text-center font-bold bg-white"
              target="_blank"
              rel="noopener noreferrer"
            >
              Carbon credits project development
            </a>
            <p className="text-[15px] font-medium text-center px-8">
              Cook up some eco-magic with projects that  churn out carbon
              credits! It’s like crafting your own green gold and making
              sustainability your ultimate desire.
            </p>
          </div>
          <div className="flex flex-col w-1/4 rounded-md shadow-lg  bg-white h-[400px]">
            <div className="pt-6 flex justify-center items-center pb-4">
              <img src="images/offering6.svg" alt="about-us" />
            </div>

            <a
              href="https://www.offsetgo.earth/carbon-mitigation-reduction-service"
              className="block mb-4 text-[16px] text-center font-bold bg-white"
              target="_blank"
              rel="noopener noreferrer"
            >
              Mitigation & Reduction
            </a>

            <p className="text-[15px] font-medium text-center px-8">
              Swap those carbon credits like you’re at the coolest eco-exchange!
              Buy, sell, and trade your way to a greener future, turning
              emissions into opportunities with a touch of green swagger.
            </p>
          </div>{" "}
          <div className="flex flex-col w-1/4 rounded-md shadow-lg  bg-white h-[400px]">
            <div className="pt-6 flex justify-center items-center pb-4">
              <img src="images/offering7.svg" alt="about-us" />
            </div>

            <a
              href="https://www.offsetgo.earth/life-cycle-assessment-service"
              className="block mb-4 text-[16px] text-center font-bold bg-white"
              target="_blank"
              rel="noopener noreferrer"
            >
              Life Cycle Assesment
            </a>
            <p className="text-[15px] font-medium text-center px-8">
              Ready to be a climate hero? Balance your carbon game like a pro,
              achieving that sweet spot where you’re giving back as much as you
              take.
            </p>
          </div>{" "}
          <div className="flex flex-col w-1/4 rounded-md shadow-lg  bg-white h-[400px]">
            <div className="pt-6 flex justify-center items-center pb-4">
              <img src="images/offering8.svg" alt="about-us" />
            </div>
            <a
              href="https://www.offsetgo.earth/esg-reporting-service"
              className="block mb-4 text-[16px] text-center font-bold bg-white"
              target="_blank"
              rel="noopener noreferrer"
            >
              ESG Reporting
            </a>
            <p className="text-[15px] font-medium text-center px-8">
              Get all-in-one access to a buffet of sustainability solutions.
              It’s like a VIP pass to the coolest green club where every service
              is tailored to make your eco-journey awesome.
            </p>
          </div>
        </div>
      </div>
      <div className="flex mt-6">
        <div className=" w-3/5 py-8 text-[28px] px-20 mb-16 ">
          <h1 className=" font-bold mb-4   ">
            About <span className="text-blue-800">Carburn</span> Tool
          </h1>
          <p className="text-[16px] font-medium pb-6">
            The CARBURN tool is a robust solution designed to calculate Scope 1,
            2, and 3 emissions for organisations, providing a comprehensive
            understanding of their carbon footprint. By utilizing detailed
            questionnaire survey forms, CARBURN captures extensive data across
            all operational aspects. Carburn offers two dashboards- one for the
            company and one for services rendered by the company. It also
            provides their client with post-service accessibility of the
            dashboards ensuring continuous access to important information and
            supports white-label reporting. It has features that allow users to
            save their progress as drafts and view quarterly data separately on
            the dashboard. Carburn facilitates data collection from vendors in
            two ways, either by allowing companies to control vendor selection
            and scope or by enabling vendors to input data independently. The
            tool’s structured approach facilitates accurate and detailed
            emissions calculations, helping organisations identify key areas for
            improvement and develop effective sustainability strategies.
          </p>
          <Button
            varient="primary"
            borderColor="black"
            color="blue"
            className="text-sm w-[160px] py-3 font-normal text-white mr-5"
          >
            Know More
          </Button>
        </div>
        <div className="w-2/5 px-8">
          {" "}
          <img src="images/carbon-tool.svg" alt="about-us" />
        </div>
      </div>
    </div>
  );
};

export default AboutUsBody;
